import React, { useContext, useEffect, useState, useRef } from "react"
import "./Login.scss"
import { Link, useNavigate } from "react-router-dom"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Form,
  Alert,
  Input,
  FormFeedback,
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import PropTypes from "prop-types"
import PixwikLogo from "../../assets/pixwik/logo.png"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import withRouter from "components/Common/withRouter"

import AuthenticationApi from "Api/AuthenticationApi"
import EncryptPassword from "utils/EncryptPassword/EncryptPassword"
import UserContext from "ContextProvider/UserContext"
import { Toast } from "primereact/toast"
import "react-toastify/dist/ReactToastify.css"
import { Spinner } from "reactstrap"

const Login = props => {
  const [otpDialog, setOtpDialog] = useState(false)
  const [loading, setLoading] = useState(false)
  const [otpLoading, setOtpLoading] = useState(false)
  const navigate = useNavigate("")
  const { setUserData } = useContext(UserContext)

  const toast = useRef(null);

  useEffect(() => {
    document.title = "Login - Pixwik"
  }, [])

  const validation = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: values => {
      handleLogin(values.email, values.password)
    },
  })

  const otpValidation = useFormik({
    initialValues: {
      email: "",
      otp: "",
    },
    validationSchema: Yup.object({
      otp: Yup.string().required("Please Enter Your OTP"),
    }),
    onSubmit: values => {
      handleOtpVerification(values.email, values.otp)
    },
  })

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    error: login.error,
  }))

  const { error } = useSelector(LoginProperties)

  const handleLogin = (email, password) => {
    setLoading(true)
    const payload = {
      email: email,
      password: EncryptPassword(password),
      // password: password,
    }


    AuthenticationApi.login(payload)
      .then(res => {
        setLoading(false)
        if (res.data.status) {
          setOtpDialog(true)
          otpValidation.setFieldValue("email", email)
          validation.resetForm()
          toast.current.show({ severity: 'success', summary: 'Success', detail: 'OTP send to email', life: 3000 });
        }
      })
      .catch(err => {
        setLoading(false)
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Login failed!.Enter valid Details', life: 3000 });
      })
  }

  const handleOtpVerification = (email, otp) => {
    setOtpLoading(true)
    const payload = {
      email: email,
      otp: otp,
    }

    AuthenticationApi.verifyLogin(payload)
      .then(res => {
        localStorage.setItem("accessToken", res.data.token)
        localStorage.setItem("userData", JSON.stringify(res.data.userData))
        setUserData(res.data.userData)
        navigate("/")
        otpValidation.resetForm()
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'OTP verified successfully! welcome to pixwik adminpannel', life: 3000 });
        setOtpLoading(false)
      })
      .catch(err => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'OTP verification failed.', life: 3000 });
        setOtpLoading(false)
      })
  }

  return (
    <React.Fragment>
      <div
        className="account-pages login-page  d-flex align-items-center justify-content-center"
        style={{ height: "100vh" }}
      >
        <Container>
          <Row className="justify-content-center ">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden ">
                <CardBody className="pt-0 login-card">
                  <h3 className="text-center mt-5 mb-2">
                    <img
                      src={PixwikLogo}
                      alt="Pixwik Logo"
                      height="30"
                      className="auth-logo-light"
                    />
                  </h3>

                  {otpDialog ? (
                    <div className="px-3  py-3">
                      <h4 className="text-muted font-size-18 mb-1 text-center">
                        OTP Verification
                      </h4>
                      <p className="text-muted text-center">
                        Enter the OTP sent to your email{" "}
                        {validation.values.email}
                      </p>

                      <Form
                        className="form-horizontal mt-2"
                        onSubmit={e => {
                          e.preventDefault()
                          otpValidation.handleSubmit()
                          return false
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}
                        <div className="mb-3">
                          <Label htmlFor="otp">Enter OTP</Label>
                          <Input
                            name="otp"
                            className="form-control"
                            placeholder="Enter Otp"
                            type="text"
                            onChange={otpValidation.handleChange}
                            onBlur={otpValidation.handleBlur}
                            value={otpValidation.values.otp || ""}
                            invalid={
                              otpValidation.touched.otp &&
                                otpValidation.errors.otp
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                            validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <Row className="mb-3 mt-4">
                          <div className="col-6 back-button-otp user-select-none d-flex align-items-center">
                            <span
                              className="d-flex align-items-center justify-content-center"
                              onClick={() => {
                                setOtpDialog(false)
                                otpValidation.resetForm()
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                className="pi ion ion-ios-arrow-back "
                                style={{ marginRight: "5px" }}
                              />
                              Back
                            </span>
                          </div>

                          <div className="col-6 text-end">
                            <button
                              className="btn btn-primary w-md waves-effect waves-light"
                              type="submit"
                              disabled={otpLoading}
                            >
                              {otpLoading ? <Spinner size="sm" /> : "Verify"}
                            </button>
                          </div>
                        </Row>
                      </Form>
                    </div>
                  ) : (
                    <div className="px-3 py-3">
                      <h4 className="text-muted font-size-18 mb-1 text-center">
                        Welcome Back !
                      </h4>
                      <p className="text-muted text-center">
                        Sign in to continue to Pixwik.
                      </p>
                      <Form
                        className="form-horizontal mt-2"
                        onSubmit={validation.handleSubmit}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}
                        <div className="mb-3">
                          <Label htmlFor="email">Email</Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                                validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                            validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="userpassword">Password</Label>
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type="password"
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                                validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                            validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <Row className="mb-3 mt-4">
                          <div className="col-6">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="customControlInline"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="customControlInline"
                              >
                                Remember me
                              </label>
                            </div>
                          </div>
                          <div className="col-6 text-end">
                            <button
                              className="btn btn-primary w-md waves-effect waves-light"
                              type="submit"
                              disabled={loading}
                            >
                              {loading ? <Spinner size="sm" /> : "Log In"}
                            </button>
                          </div>
                        </Row>
                        <Row className="form-group mb-0">
                          <Link to="/forgot-password" className="text-muted">
                            <i className="mdi mdi-lock"></i> Forgot your
                            password?
                          </Link>
                        </Row>
                      </Form>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Toast ref={toast} />
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
